export const API_URL = process.env.REACT_APP_BACKEND_API_URL!;

export const MOCK_API_URL = process.env.REACT_APP_MOCK_API_URL!;

// API Endpoints
export const API_ENDPOINTS = {
  // Auth
  LOGIN: `${API_URL}/auth/login`,
  CHECK_EMAIL: `${API_URL}/auth/checkEmail`,

  // Fuzzy Search
  FUZZY_SEARCH: `${API_URL}/fuzzy/fuzzySearch`,
  FUZZY_WITH_ITEM_SEARCH: `${API_URL}/fuzzy/fuzzyWithItemSearch`,
  EXTRACT_KEYWORDS: `${API_URL}/fuzzy/extractKeywords`,

  // Departments
  DEPARTMENTS: `${API_URL}/departments`,

  // Positions
  POSITIONS: `${API_URL}/positions`,

  // Companies
  COMPANIES: `${API_URL}/companies`,

  // Talents
  TALENTS: `${API_URL}/talents`,

  // Profiles
  PROFILES: `${API_URL}/profiles`,
} as const;
